// The live server answers a missing .php file with the React index.html and no
// CORS headers, which axios reports only as "Network Error". Turn that into a
// message that says what is actually wrong.
export const apiErrorMessage = (err, phpFile, fallback) => {
  if (err?.message === "NOT_DEPLOYED" || (err?.message === "Network Error" && !err?.response)) {
    return `Server API not found: upload api/${phpFile} to the server (or check your internet connection).`;
  }
  return err?.response?.data?.message || err?.message || fallback;
};
